<template>
    <div>
        <div class="page-filter-box">
            <el-row :gutter="20">
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-input v-model="params.title" placeholder="商品名称" size="small"></el-input>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.status" placeholder="请选择" size="small">
                        <el-option label="仅看上架中的" :value="0"></el-option>
                        <el-option label="仅看已下架的" :value="1"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.categoryId" placeholder="请选择" size="small">
                        <el-option label="所有分类" value=""></el-option>
                        <el-option v-for="(item,index) in goodsCategory" :key="index" :label="item.name" :value="item.id"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-btns-box">
            <el-button v-if="$utils.have('/point/goods/save')" type="primary" icon="el-icon-plus" size="small" @click="add()">创建商品</el-button>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column label="商品">
                    <template slot-scope="{row} = scope">
                        <div class="goods-info">
                            <el-image :src="row.coverImage | coverImage(120,120)" fit="cover" :preview-src-list="[row.coverImage]"></el-image>
                            <p>{{ row.title }}</p>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="categoryName" label="商品分类"></el-table-column>
                <el-table-column prop="redeemPoint" label="兑换积分"></el-table-column>
                <el-table-column prop="stock" label="库存">
                    <template slot-scope="{row} = scope">
                        {{ row.stock == -1 ? '不限' : row.stock}}
                    </template>
                </el-table-column>
                <el-table-column prop="sellNum" label="销量"></el-table-column>
                <!-- <el-table-column prop="status" label="状态">
                    <template slot-scope="{row} = scope">
                        <el-tag v-if="row.status == 0" type="success" size="mini">上架中</el-tag>
                        <el-tag v-else-if="row.status == 1" type="danger" size="mini">已下架</el-tag>
                        <el-tag v-else type="info" size="mini">已删除</el-tag>
                    </template>
                </el-table-column> -->
                <el-table-column fixed="right" label="操作" width="120">
                    <template slot-scope="{row} = scope">
                        <el-button v-if="$utils.have('/point/goods/save')" type="text" size="small" @click="edit(row.id)" >编辑</el-button>
                        <el-button v-if="$utils.have('/point/goods/updateStatus')" type="text" size="small" @click="updateStatus(row)" >{{ row.status == 0 ? '下架' : '上架' }}</el-button>
                        <el-button v-if="$utils.have('/point/goods/updateStatus')" type="text" size="small" @click="updateStatus(row, 2)" >删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="handleSizeChange"
                @current-change="getDataList"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import {fetchPointsGoodsCategory} from '@/assets/js/commonApi.js'
const defaultParams = {
    pageNo: 1,
    title: "",
    status: 0,
    categoryId: ""
}
export default {
    data(){
        return{
            data: null,
            dataList: null,
            params:{
                ...defaultParams,
                pageNo: parseInt(this.$route.query.pageNo || 1),
                pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
                status: parseInt(this.$route.query.status) || 0,
                title: this.$route.query.title || "",
                categoryId: parseInt(this.$route.query.categoryId) || "",
            },
            listLoading: true,
            goodsCategory: []
        }
    },
    mounted() {
        this.getGoodsCategory();
        this.getDataList();
    },
    methods: {
        // 获取所有积分商品类型
        getGoodsCategory(){
            fetchPointsGoodsCategory().then((res) => {
                const { state, msg, result } = res.data;
                if ( state == 1 && result) {
					this.goodsCategory = result || [];
				} else {
					this.$message.error(msg || "获取商品分类失败");
				}
            }).catch(() => {
				this.$message.error("获取商品分类失败");
			})
        },

        //获取列表
        getDataList() {
            this.listLoading = true;
            this.$request({
                url: "/point/goods/list",
                method: "POST",
                data: {
                    ...this.params
                },
            })
			.then((res) => {
				const { state, msg, result } = res.data;
				if ( state == 1 && result) {
					this.data = result;
					this.dataList = result.result || [];
				} else {
					this.$message.error(msg || "请求失败");
				}
			})
			.catch(() => {
				this.$message.error("请求错误");
			})
			.finally(() => {
				this.listLoading = false;
			});
        },
        //选择pageSize
        handleSizeChange(e) {
            this.params.pageNo = 1;
            this.params.pageSize = e;
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {
                ...defaultParams,
                pageSize: this.params.pageSize,
            };
            this.getDataList();
        },
        add(){
            this.$router.push('/operation/pointsGoods/add')
        },
        edit(id){
            this.$router.push({
                path: `/operation/pointsGoods/edit/${id}`,
                query: {
                    redirect: this.$utils.objArgs(
                        this.$router.currentRoute.path,
                        this.params
                    ),
                },
            });
        },
        // 更新状态
        updateStatus(o,s){
            let msg = '确定下架此商品吗？', title = '下架', status = s || 1;
            if( status == 2 ){ //删除
                msg = '确定删除此商品吗？',
                title = '删除'
            }else{
                if( o.status == 1 ){
                    msg = '确定上架此商品吗？',
                    title = '上架'
                    status = 0
                }
            }

            this.$confirm(msg, title, {
                type: 'warning',
                center: true,
                closeOnClickModal: false
            }).then(() => {
                this.listLoading = true;
                this.$request({
                    url: "/point/goods/updateStatus",
                    method: "POST",
                    params: {
                        id: o.id,
                        status: status
                    },
                })
                .then((res) => {
                    const { state, msg, result } = res.data;
                    if ( state == 1) {
                        this.search();
                    } else {
                        this.$message.error(msg || "请求失败");
                    }
                })
                .catch(() => {
                    this.$message.error("请求错误");
                })
            }).catch(() => {})
        }
    }
}
</script>

<style lang="scss" scoped>
 .goods-info{
    display: flex;
    align-items: center;
    .el-image{
        width: 60px;
        height: 60px;
        margin-right: 10px;
    }
    p{
        flex: 1;
    }
 }
</style>